import "./scss/global.scss"

import { ScrollTrigger } from "gsap/ScrollTrigger"
import debounce from "lodash.debounce"
import { createApp, defineAsyncComponent } from "vue"

import { createPinia } from 'pinia'
// import { useBreakpoints } from "@vueuse/core";
// import { OnClickOutside } from "@vueuse/components";
// import { ExpandTransition, FadeTransition } from "@bam/transitions";

import { initSectionAnimations } from "./animations/init.js"

let { height: bodyHeight, width: bodyWidth } = document.body.getBoundingClientRect().height;
const handleResize = debounce((entries, observer) => {
    const [ entry, ..._ ] = entries

    const newHeight = Math.round(entry.contentRect.height)
    const newWidth = Math.round(entry.contentRect.width)

    if (newHeight != bodyHeight || bodyWidth != newWidth) {
        bodyHeight = newHeight
        bodyWidth = newWidth
        setVh()
        ScrollTrigger.refresh();
    }
}, 30)
const resizeObserver = new ResizeObserver(handleResize);
resizeObserver.observe(document.body)

function setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}
setVh()
const handleWindowResize = debounce(() => { setVh() }, 50)
window.addEventListener('scroll', setVh, { passive: true })
// window.addEventListener('resize', (event) => { console.log(window.innerHeight); handleWindowResize(event)})
window.addEventListener('orientationchange', handleWindowResize)


Promise
    .all(
        Array.from(document.images)
            .filter(img => !img.complete)
            .map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))
    )
    .then(() => {
        window.setTimeout(() => { ScrollTrigger.refresh(); }, 0)
    });

// window.addEventListener("hashchange", () => {
//     setVh()
//     ScrollTrigger.refresh()
// })

// document.addEventListener("click", (event) => {
//     const { target } = event
//     const link = target.matches('a[href*="#"]')
//         ? target
//         : target.closest('a[href*="#"]')

//     if (!link) return;

//     const url = new URL(link.getAttribute("href"));
//     if (!(
//         url.protocol === location.protocol
//         && url.origin === location.origin
//         && url.pathname === location.pathname
//     )) {
//         return
//     }

//     event.preventDefault();

//     if (url.hash === "") {
//         history.pushState(null, null, url)
//         gsap.to(window, { scrollTo: { y: 0, autoKill: false } });
//         return
//     }

//     const href = url.hash.split('#').slice(1).join('#')
//     const hrefTarget = document.getElementById(href)
//     if (!hrefTarget) {
//         return
//     }

//     history.pushState(null, null, url)
//     gsap.to(window, { scrollTo: { y: hrefTarget, offsetY: 50, autoKill: false } });
// })

const app = createApp({
    data: () => {
        return {
            // globalSwiperModules: [Pagination, Parallax],
        };
    },
    update() {
        // console.log("vue update")
        ScrollTrigger.refresh()
    },
    mounted() {
        // Defer swiper element registration: it's only needed for
        // <swiper-container> elements that are below the fold on most
        // pages. Splits ~70KB gzip out of the initial bundle.
        if (document.querySelector("swiper-container")) {
            const loadSwiper = () => import("swiper/element/bundle").then(({ register }) => register())
            "requestIdleCallback" in window
                ? requestIdleCallback(loadSwiper, { timeout: 2000 })
                : setTimeout(loadSwiper, 0)
        }

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        setTimeout(() => {

            if (!prefersReducedMotion) {
                initSectionAnimations();
            }
            ScrollTrigger.refresh()
        }, 0)
    },
});

const pinia = createPinia()
app.use(pinia)

// app.config.compilerOptions.isCustomElement = (tag) => {
//     return tag.startsWith('swiper')
// }
// const bps = JSON.parse(
//     getComputedStyle(document.body).getPropertyValue("--bam-breakpoints")
// );
// const breakpoints = useBreakpoints(bps);
// app.config.globalProperties.$breakpoints = breakpoints;

// Lazy-by-default: every Vue component is fetched on demand via
// defineAsyncComponent. Only the components that are reliably present
// above the fold ship in the initial bundle.
const eagerComponents = import.meta.glob([
    "./components/TheHeader.vue",
    "./components/StickyHeaderObserver.vue",
    "./components/VideoPlayer.vue",
    "./components/ShowMore.vue",
    "./components/FadeTransition.vue",
], { eager: true });
const lazyComponents = import.meta.glob([
    "./components/**/*.vue",
    "!./components/TheHeader.vue",
    "!./components/StickyHeaderObserver.vue",
    "!./components/VideoPlayer.vue",
    "!./components/ShowMore.vue",
    "!./components/FadeTransition.vue",
    "!./components/TestimonialItem.vue",
    "!./components/TestimonialSlider.vue",
    "!./components/StickyText.vue",
    "!./components/OverflowMenu.vue",
    "!./components/SearchParams.vue",
    "!./components/CaseSlider.vue",
    // Disabled: not referenced from any template. File kept for revival.
    "!./components/SiteSwitcher.vue",
    "!./components/TextImageStackSlider.vue",
]);
const nameFromPath = (path) => path.split("/").pop().replace(/\.\w+$/, "")

Object.entries(eagerComponents).forEach(([path, definition]) => {
    app.component(nameFromPath(path), definition.default);
});
Object.entries(lazyComponents).forEach(([path, loader]) => {
    app.component(nameFromPath(path), defineAsyncComponent(loader));
});

// app.component("expand-transition", ExpandTransition);
// app.component("fade-transition", FadeTransition);
// app.component("on-click-outside", OnClickOutside);

app.mount("#app");

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
// if (import.meta.hot) {
//     import.meta.hot.accept();
// }

if (document.querySelector("[data-fancybox]")) {
    import("./vanilla/fanybox").then(({ init }) => init())
}

function pgshow(e) {
    const hash = window.location.hash;
    if (!hash || hash.length <= 1) { return }

    const el = document.getElementById(hash.slice(1));
    if (el) el.scrollIntoView(true);
}
window.addEventListener("pageshow", pgshow);

